export const NAV_ITEMS = [
  { to: '/scan-details', label: 'Scan Details', icon: 'document_scanner' },
  { to: '/users', label: 'Users', icon: 'group' },
  { to: '/coupons', label: 'Coupons', icon: 'confirmation_number' },
  { to: '/onboarding-config', label: 'Onboarding Fuel Configuration', icon: 'how_to_reg' },
  { to: '/gas-stations', label: 'Gas Stations', icon: 'local_gas_station' },
  { to: '/feedback', label: 'Feedback', icon: 'feedback' },
];
